"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.cities = void 0;
const autonomies_1 = require("./autonomies");
const cities_json_1 = __importDefault(require("./data/cities.json"));
const provinces_1 = require("./provinces");
/**
 * Returns an array of cities that match the specified filter criteria.
 * @param filters (optional) An object with filters.
 * @param filters.code A string or number representing the code of the city to filter by.
 * @param filters.code_autonomy A string or number representing the code of the autonomy to filter by.
 * @param filters.code_province A string or number representing the code of the province to filter by.
 * @param filters.name A string representing the name of the city to filter by.
 * @param filters.with_autonomy A boolean indicating if the result should include the autonomy associated with each city.
 * @param filters.with_province A boolean indicating if the result should include the province associated with each city.
 */
const cities = (filters = {}) => {
    const { code, code_autonomy, code_province, name, with_autonomy = false, with_province = false } = filters;
    const filtered = cities_json_1.default.filter((city) => (code === undefined || city.code == code) &&
        (code_autonomy === undefined || city.code_autonomy == code_autonomy) &&
        (code_province === undefined || city.code_province == code_province) &&
        (name === undefined || city.name.toLocaleLowerCase().includes(name.toLocaleLowerCase())));
    return filtered.map((city) => (Object.assign(Object.assign(Object.assign({}, city), (with_autonomy && { autonomy: (0, autonomies_1.autonomies)({ code: city.code_autonomy })[0] })), (with_province && { province: (0, provinces_1.provinces)({ code: city.code_province })[0] }))));
};
exports.cities = cities;
